import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { WORKSPACE_USER_CACHE_KEYS } from "@hooks/useWorkspaceUserCache";

export const createDefaultCounterpartyGlDrillDownTransactionView = (
    ledgerBasis: AccountingLedgerBasis | undefined,
    { isClassesEnabled }: { isClassesEnabled: boolean },
): NamedView<TransactionView> => ({
    id: "counterparty-general-ledger-drilldown",
    name: "Counterparty GL drilldown",
    type: ViewType.TRANSACTION,
    options: {
        bulkActions: true,
        selection: true,
    },
    filters: {},
    columns: [
        {
            id: TransactionColumn.DATE,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.BANK_DESCRIPTION,
        },
        {
            id: TransactionColumn.COUNTERPARTY,
        },
        {
            id:
                ledgerBasis === AccountingLedgerBasis.accruals
                    ? TransactionColumn.ACCRUAL_LEDGER
                    : TransactionColumn.LEDGER,
        },
        ...(isClassesEnabled
            ? [{ id: TransactionColumn.CLASSES as const }]
            : []),
        {
            id: TransactionColumn.EXCLUDE_FROM_1099,
        },
        {
            id: TransactionColumn.ACCOUNT,
        },
        {
            id: TransactionColumn.AMOUNT,
            options: {
                pin: "right",
            },
        },
        {
            id: TransactionColumn.ENTITY,
            options: {
                pin: "right",
            },
        },
    ],
});

export const getCounterpartyGlTransactionsDrilldownCacheKey = (
    ledgerBasis: AccountingLedgerBasis,
): WORKSPACE_USER_CACHE_KEYS =>
    ledgerBasis === AccountingLedgerBasis.accruals
        ? WORKSPACE_USER_CACHE_KEYS.COUNTERPARTY_GL_ACCRUAL_TRANSACTIONS_DRILLDOWN_VIEW_CACHE_KEY
        : WORKSPACE_USER_CACHE_KEYS.COUNTERPARTY_GL_CASH_TRANSACTIONS_DRILLDOWN_VIEW_CACHE_KEY;
